"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetailerCatalog = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _Avatar = require("../Avatar");

var _styles = require("./styles");

var _customHooks = require("../../../global-files/customHooks");

var _RetailersList = require("../RetailersList");

var _jsxRuntime = require("react/jsx-runtime");

var RetailerCatalog = function RetailerCatalog(_ref) {
  var _ref$retailers = _ref.retailers,
      retailers = _ref$retailers === void 0 ? [] : _ref$retailers,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 3 : _ref$limit,
      article = _ref.article,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "retailers-catalog" : _ref$id;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      retLimit = _useState2[0],
      setRetLimit = _useState2[1];

  var _useCloseModal = (0, _customHooks.useCloseModal)(id),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showRetailers = _useCloseModal2[0],
      setShowRetailers = _useCloseModal2[1];

  (0, _react.useEffect)(function () {
    setRetLimit(limit);
  }, [retailers]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    onClick: function onClick(e) {
      setShowRetailers(!showRetailers);
    },
    id: id,
    children: [retailers.map(function (retailer, i) {
      return i < limit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
        image: "https://content-management-images.s3.amazonaws.com/retailers/".concat(retailer.id, ".png"),
        altText: retailer === null || retailer === void 0 ? void 0 : retailer.name,
        imageType: "medium-image"
      }, retailer.id + "-" + i);
    }), retailers.length > retLimit && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "retailers-limit",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        children: ["+", retailers.length - retLimit]
      })
    }), showRetailers && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RetailersList.RetailersList, {
      retailers: retailers,
      article: article
    })]
  });
};

exports.RetailerCatalog = RetailerCatalog;